export class ConfigurationTreeDataModel {
  id: number;
  name: string;
  text: string;
  color: string;
  routerLink: string;
  iconPath: string;
  isEnabled: boolean;
  isSelected: boolean;
  isHovered: boolean;
  routeType: string;
  

  children = new Array<ConfigurationTreeDataModel>();
  queryParams: object;

  constructor(id: number, name: string, text: string, color: string, routerLink: string, iconPath: string, enabled: boolean = true, routeType = 'configuration') {
    this.id = id;
    this.name = name;
    this.text = text;
    this.color = color;
    this.routerLink = routerLink;
    this.iconPath = iconPath;
    this.isEnabled = enabled;
    this.routeType = routeType;
    
  }
}
